/**
 * Inventory-related types shared between backend and frontend
 */

/**
 * Status of inventory availability check
 */
export enum InventoryStatus {
  /** Available quantity meets or exceeds requested quantity */
  SUFFICIENT = "SUFFICIENT",
  /** Available quantity is less than requested quantity */
  INSUFFICIENT = "INSUFFICIENT",
  /** Unable to determine inventory status (e.g., no connection, item not found) */
  UNKNOWN = "UNKNOWN",
  /** Item is marked as inactive and cannot be fulfilled */
  INACTIVE = "INACTIVE",
}

/**
 * Result of an inventory validation check for a line item
 */
export interface InventoryValidationResult {
  /** Status of the inventory check */
  status: InventoryStatus;
  /** Quantity requested on the line item */
  requestedQuantity: number;
  /** Available quantity (on-hand minus reserved), null if unknown */
  availableQuantity: number | null;
  /** Total on-hand quantity, null if unknown */
  onhandQuantity: number | null;
  /** Reserved quantity, null if unknown */
  reservedQuantity: number | null;
  /** Organization code used for the query */
  organizationCode: string | null;
  /** Item number/SKU used for the query */
  itemNumber: string | null;
  /** Error message if the check failed */
  errorMessage?: string;
  /** Raw item status from the ERP system (e.g. "Active", "Inactive") */
  itemStatus?: string;
}
